<div class="flxClmn dashboard-page" style="position: relative;"
	 [ngStyle]="generatePdfInProcess && {'overflow' : 'hidden'}">

	<div class="page-inner-content-holder bs-enabled" style="background: white; padding-top: 0; position: relative;"
		 [ngClass]="{'no-scroll' : generatePdfInProcess}"
		 [ngStyle]="{'overflow' : generatePdfInProcess ? 'hidden' : ''}">
		<!--generate pdf loader-->
		<div *ngIf="generatePdfInProcess" class="pdf-generate-loader">
			<div style=" position: absolute; top: calc(50vh - 200px - 40px); left: 50%; transform: translate(-50%,0); align-items: center;"
				 class="flxClmn vSpace2">
				<loader height="80" width="80" style="opacity: 0.8;"></loader>
				<span style="position: relative; font-size: 1rem; font-weight: 500; color: var(--ui-text-muted);" class="loading-dots">Generating PDF. Please wait</span>
			</div>
		</div>

		<div class="flxRow-between gap-2 mt-0 animated fadeIn" style="position: relative; z-index: 45; align-items: flex-start; margin: 20px 0; white-space: nowrap; flex-wrap: wrap;">
			<div class="flxRow gap-2 f-1-0" style="align-items: center; flex-wrap: wrap;">
				<div class="period-buttons-group bs-enabled flxRow gap-2">
					<button class="period-button bs-btn bs-btn-light h-100"
							*ngFor="let item of dashboardPeriod | keyvalue: gs.returnZero"
							[ngClass]="{'chosen' : period === item.value, 'd-none' : item.value.display === dic.CONSTANTS.trendsPeriod.range.display}"
							(click)="changePeriod(item.value);">
						{{item.value.display}}
					</button>
					<div class="position-relative range-button">
					<button class="period-button gap-1 bs-btn bs-btn-light h-100" id="customPeriodBtn"
							[ngClass]="{'chosen' : period?.display === dic.CONSTANTS.trendsPeriod.range.display && !comparisonService.comparisonActive}"
							(click)="showTrendsCustomPeriod = !showTrendsCustomPeriod;">
								<span *ngIf="period?.display === dic.CONSTANTS.trendsPeriod.range.display && !comparisonService.comparisonActive" style="font-weight: 300;">
									From <b class="px-2">{{range.start | date:'MM/dd/yyyy'}}</b> Until <b class="px-2">{{range.end | date:'MM/dd/yyyy'}}</b>
								</span>
						<span *ngIf="period?.display !== dic.CONSTANTS.trendsPeriod.range.display || comparisonService.comparisonActive">
									Custom
								</span>
						<i class="fas fa-sort-down" style="margin-top: -5px;"></i>
					</button>
					<!--custom period modal-->
					<div class="drop-menu mt-1 p-2" style="width: fit-content; max-width: none; min-width: 300px; overflow: visible; min-height: 0;"
						 [ngClass]="{'active' : showTrendsCustomPeriod}">
						<div class="p-3 text-start m-0 flex-row align-items-center gap-2" (clickOutside)="showTrendsCustomPeriod = false;"
							 style="min-width: 490px;"
							 [exclude]="'#customPeriodBtn'">
							<div class="flxRow hSpace05 f-1-0" style="align-items: center;">
								<span>Date Range:</span>
								<date-picker-c class="f-1-0"
										   [(dateModel)]="range"
										   [isRange]="true"
										   [dateFormat]="'mm/dd/yyyy'">
								</date-picker-c>
							</div>
							<btn-c endIcon="zmdi zmdi-check"
								   [loading]="getTrendsDataInProcess"
								   (action)="changePeriod(dic.CONSTANTS.trendsPeriod.range);">
								Get Trends
							</btn-c>
						</div>
					</div>
				</div>
			<div class="position-relative range-button">
				<button class="period-button hSpace05 bs-btn bs-btn-light h-100" id="comparePeriodsBtn"
						[ngClass]="{'chosen': comparisonService.comparisonActive, 'disabled': comparisonService.comparisonLoading}"
						(click)="openComparePicker();">
					<span *ngIf="comparisonService.comparisonActive" style="font-weight: 300;">
						<b class="px-2">{{comparisonService.currentPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MM/yyyy' : 'MM/dd/yy')}}</b>
						<i class="far fa-exchange-alt"></i>
						<b class="px-2">{{comparisonService.comparedPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MM/yyyy' : 'MM/dd/yy')}}</b>
					</span>
					<span *ngIf="!comparisonService.comparisonActive">Compare</span>
					<i class="fas fa-sort-down" style="margin-top: -5px;"></i>
				</button>
				<div class="drop-menu mt-1 p-2" style="width: fit-content; max-width: none; overflow: visible; min-height: 0; right: -300px; left: auto;"
					 [ngClass]="{'active': showComparePicker}">
					<div class="p-2" (clickOutside)="showComparePicker = false;" [exclude]="'#comparePeriodsBtn'">
						<period-comparison-picker-c (onConfirm)="showComparePicker = false"></period-comparison-picker-c>
					</div>
				</div>
			</div>
			</div>

				<div class="flxRow hSpace1" style="align-items: center; flex-shrink: 0; background: var(--ui-surface-2); border-radius: 999px; padding: 3px 6px 3px 12px;" *ngIf="showAbortLoadingEmailsLabel || comparisonService.comparisonLoading">
					<i class="far fa-spin fa-spinner" style="color: var(--ui-brand); font-size: 12px;"></i>
					<span style="font-weight: 500; color: var(--ui-text-muted); white-space: nowrap;">Processing</span>
					<span style="font-weight: 600; color: var(--ui-text); min-width: 34px;" *ngIf="comparisonService.comparisonLoading && comparisonService.comparisonProgressPercent">{{comparisonService.comparisonProgressPercent}}%</span>
					<div style="width: 80px; height: 4px; border-radius: 999px; background: var(--ui-border); overflow: hidden;" *ngIf="comparisonService.comparisonLoading && comparisonService.comparisonProgressPercent">
						<div style="height: 100%; border-radius: 999px; background: var(--ui-brand); transition: width 0.3s;" [style.width.%]="comparisonService.comparisonProgressPercent"></div>
					</div>
					<btn-c variant="text" color="danger"
						   style="min-width: 0;"
						   *ngIf="showAbortLoadingEmailsLabel || comparisonService.comparisonActive"
						   (action)="comparisonService.comparisonActive ? comparisonService.abortComparisonBatches() : abortLoadingEmails();">
						Abort
					</btn-c>
				</div>
			</div>

			<div class="flxRow hSpace1" style="align-items: center; flex-shrink: 0;">
				<btn-c endIcon="far fa-file-download" variant="outlined"
					   [loading]="generatePdfInProcess"
					   [isDisabled]="!emails?.length || getTrendsDataInProcess"
					   (action)="exportChartsToPdf();">
					Export to PDF
				</btn-c>
			</div>
		</div>

		<div *ngIf="userInfo.type !== dic.CONSTANTS.userTypes.dlp" class="flex-row justify-content-between">
			<div class="flex-row gap-3 align-items-center">
				<span>Real-time email classification monitoring
					<i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
					   tooltip='When enabled, all classification types will be automatically scanned in emails, giving you a clear picture of the data being sent'></i>
				</span>

				<div class="content-container">
					<toggle-switch-c id="sensitivity_monitor_mode"
									 [(model)]="sensitivityConfiguration.sensitivity_monitor_mode"
									 [hideText]="true"
									 (onChange)="updateMonitorMode()"></toggle-switch-c>
				</div>

				<div class="flex-row" *ngIf="!sensitivityConfiguration.sensitivity_monitor_mode">
					(<i class="far fa-exclamation mx-1"></i>
					<span>When disabled, only the sensitivity types set by your DLP rules are scanned, not all types</span>)
				</div>
			</div>

			<div class="flex-row gap-2 align-items-center">
				<label for="sensitivityScoreFilter">Score filter:</label>
				<input type="number" name="sensitivityScoreFilter" id="sensitivityScoreFilter" style="padding-left: 0.2rem;"
					   [(ngModel)]="sensitivityScoreFilter"
					   (ngModelChange)="onSensitivityScoreFilterChange()"
					   [min]="1" [max]="5" step="0.5">

				<i class="far fa-question-circle opacity-75" style="font-weight: 400;" tooltip="Show only emails with sensitivity score equal to or higher than this value. Scores range from 1 (least sensitive) to 5 (most sensitive), based on detected sensitive content."></i>
			</div>
		</div>

		<hr/>

		<div class="bs-enabled" id="trendsChartsContainer" style="--chart-pdf-layout-width: 1450px;"
		     [appTrendsComparison]="{host: this, componentClass: selfComponentClass}">
			<div class="bs-container text-center" style="max-width: none !important;"
				 [ngClass]="{'w-100' : !generatePdfInProcess}">
				<div class="bs-row trends-pdf-page-title" style="display: none;">
					<img class="mb-3" [src]="lfs.logo" style="width: 200px;"/>
				</div>
				<div class="bs-row trends-pdf-page-title" style="display: none;">
					<div class="bs-col-12 mb-4 px-4" style="background: #fdfdfd; padding: 10px;">
						<div class="flxClmn vSpace05">
							<div class="flxRow-between" style="align-items: flex-end;">
								<span style="font-weight: bold; font-size: 1.6rem; white-space: nowrap;">Classification Trends and Insights</span>
								<span style="font-size: 1.25rem; white-space: nowrap;">
									Date printed: &nbsp;
									<time>{{todayDate | date:'MM/dd/yyyy'}}</time>
								</span>
							</div>
							<div class="flxRow hSpace05" style="font-size: 1.25rem;">
								<span>Period:&nbsp;</span>
								<span *ngIf="period !== dic.CONSTANTS.trendsPeriod.range" style="white-space: nowrap;">{{period.display}}</span>
								<span *ngIf="period === dic.CONSTANTS.trendsPeriod.range" style="white-space: nowrap;">
								<time>{{range.start | date:'MM/dd/yyyy'}}</time>
								&nbsp;-&nbsp;
								<time>{{range.end | date:'MM/dd/yyyy'}}
								</time>
							</span>
							</div>
						</div>
					</div>
				</div>

				<div class="bs-row g-4">

					<!--Classification Types-->
					<div class="bs-col-6" style="height: clamp(350px,50vh,405px);"
					     [appTrendsComparisonCard]="{key: 'classificationTypesChartOptions', chartRefKey: 'classificationTypesChart'}">
						<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-2">
									<h6 class="m-0 fw-bold text-nowrap">DLP Sensitivity Types</h6>
									<div class="period-buttons-group bs-enabled flex-row gap-2 align-items-center animated fadeIn pdf-excluded">
										<button class="period-button px-2 flex-row gap-2 bs-btn bs-btn-light text-capitalize"
												*ngFor="let view of classificationTypesChartViews | keyvalue: gs.returnZero"
												[ngClass]="{'chosen' : view.value === selectedClassificationTypesChartView}"
												(click)="selectedClassificationTypesChartView = view.value; prepareClassificationTypesGraph(trendsData.classificationTypes, false)">
											<i [ngClass]="{'far fa-users' : view.value === classificationTypesChartViews.all, 'far fa-user-tie' : view.value === classificationTypesChartViews.top10}" ></i>
											<span class="w-100 text-center" >{{view.value}}</span>
										</button>
									</div>
								</div>
								<span class="opacity-75 fw-500 text-start" style="height: 16px;">
									Most commonly detected classification types in your sent emails
								</span>
							</div>
							<apx-chart class="pie-chart pie-chart-left" style="width: 100%; height: 100%;"
									   *ngIf="classificationTypesChartOptions?.series?.length && !getTrendsDataInProcess"
									   #classificationTypesChart
									   [series]="classificationTypesChartOptions.series"
									   [chart]="classificationTypesChartOptions.chart"
									   [plotOptions]="classificationTypesChartOptions.plotOptions"
									   [dataLabels]="classificationTypesChartOptions.dataLabels"
									   [colors]="classificationTypesChartOptions.colors"
									   [labels]="classificationTypesChartOptions.labels"></apx-chart>
							<trends-comparison-chart></trends-comparison-chart>

							<!--tips modal-->
							<div class="trends-card-actions-menu tips" style="right: 20px !important;"
								 *ngIf="classificationTypesChartOptions && userInfo.type !== dic.CONSTANTS.userTypes.dlp"
								 [ngClass]="{'active' : showClassificationTypesTips}">
								<i class="far fa-lightbulb" id="showClassificationTypesTips" tooltip="Tips"
								   (click)="showClassificationTypesTips = !showClassificationTypesTips"></i>
								<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
									 [ngClass]="{'active' : showClassificationTypesTips}">
									<ul style="cursor: default;" (clickOutside)="showClassificationTypesTips = false;"
										[exclude]="'#showClassificationTypesTips'" >
										<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
											<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
											<span class="fw-500">Click on any pie slice to view the emails with this type.</span>
										</div>
									</ul>
								</div>
							</div>

							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!classificationTypesChartOptions?.series?.length || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

					<!--Compliance trends-->
					<div class="bs-col-6" style="height: clamp(350px,50vh,405px);"
					     [appTrendsComparisonCard]="{key: 'classificationComplianceTrendsChartOptions', chartRefKey: 'classificationComplianceTrendsChart'}">
						<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Compliance Violations</h6>
								</div>
								<span class="opacity-75 fw-500 text-start" style="height: 16px;">
									Overview of compliance violation trends over time
								</span>
							</div>
							<apx-chart class="f-1-0 animated fadeIn clickable-chart"
									   *ngIf="classificationComplianceTrendsChartOptions?.series?.length && !getTrendsDataInProcess"
									   #classificationComplianceTrendsChart
									   [series]="classificationComplianceTrendsChartOptions.series"
									   [chart]="classificationComplianceTrendsChartOptions.chart"
									   [plotOptions]="classificationComplianceTrendsChartOptions.plotOptions"
									   [xaxis]="classificationComplianceTrendsChartOptions.xaxis"
									   [yaxis]="classificationComplianceTrendsChartOptions.yaxis"
									   [fill]="classificationComplianceTrendsChartOptions.fill"
									   [stroke]="classificationComplianceTrendsChartOptions.stroke"
									   [dataLabels]="classificationComplianceTrendsChartOptions.dataLabels"></apx-chart>
							<trends-comparison-chart></trends-comparison-chart>

							<!--tips modal-->
							<div class="trends-card-actions-menu tips" style="right: 20px !important;"
								 *ngIf="classificationComplianceTrendsChartOptions && userInfo.type !== dic.CONSTANTS.userTypes.dlp"
								 [ngClass]="{'active' : showComplianceTrendsTips}">
								<i class="far fa-lightbulb" id="showComplianceTrendsTips" tooltip="Tips"
								   (click)="showComplianceTrendsTips = !showComplianceTrendsTips"></i>
								<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
									 [ngClass]="{'active' : showComplianceTrendsTips}">
									<ul style="cursor: default;" (clickOutside)="showComplianceTrendsTips = false;"
										[exclude]="'#showComplianceTrendsTips'" >
										<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
											<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
											<span class="fw-500">Click on an area to view the emails with this type.</span>
										</div>
										<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
											<i class="far fa-info" style="flex: 0 0 16px;"></i>
											<span class="fw-500">Click any compliance label to filter it out of the chart</span>
										</div>
									</ul>
								</div>
							</div>

							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!classificationComplianceTrendsChartOptions?.series?.length || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

					<!--Sensitive Emails per Domain-->
					<div class="bs-col-6 bs-col-large-4 " style="height: clamp(350px,50vh,405px);" *ngIf="userInfo.type !== dic.CONSTANTS.userTypes.dlp"
					     [appTrendsComparisonCard]="{key: 'classificationSensitivePerDomainChartOptions', chartRefKey: 'classificationSensitivePerDomainChart'}">
						<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Top Domains Receiving Sensitive Emails</h6>
								</div>
								<span class="opacity-75 fw-500 text-start" style="height: 16px;">
									Domains that receive the highest volume of sensitive emails
								</span>
							</div>
							<div class="flex-column f-1-0 centralize animated fadeIn">
								<apx-chart style="width: 100%; flex: 1 0;"
										   *ngIf="classificationSensitivePerDomainChartOptions?.xaxis?.categories?.length && !getTrendsDataInProcess"
										   #classificationSensitivePerDomainChart
										   [series]="classificationSensitivePerDomainChartOptions.series"
										   [chart]="classificationSensitivePerDomainChartOptions.chart"
										   [plotOptions]="classificationSensitivePerDomainChartOptions.plotOptions"
										   [xaxis]="classificationSensitivePerDomainChartOptions.xaxis"
										   [colors]="classificationSensitivePerDomainChartOptions.colors"
										   [dataLabels]="classificationSensitivePerDomainChartOptions.dataLabels"></apx-chart>
							</div>
							<trends-comparison-chart></trends-comparison-chart>

							<!--tips modal-->
							<div class="trends-card-actions-menu tips" style="right: 20px !important;"
								 *ngIf="classificationSensitivePerDomainChartOptions && userInfo.type !== dic.CONSTANTS.userTypes.dlp"
								 [ngClass]="{'active' : showSensitivePerDomainTips}">
								<i class="far fa-lightbulb" id="showSensitivePerDomainTipsT" tooltip="Tips"
								   (click)="showSensitivePerDomainTips = !showSensitivePerDomainTips"></i>
								<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
									 [ngClass]="{'active' : showSensitivePerDomainTips}">
									<ul style="cursor: default;" (clickOutside)="showSensitivePerDomainTips = false;"
										[exclude]="'#showSensitivePerDomainTipsT'" >
										<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
											<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
											<span class="fw-500">Click on any bar to view the emails with this type.</span>
										</div>
									</ul>
								</div>
							</div>

							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!classificationSensitivePerDomainChartOptions?.xaxis?.categories?.length || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

					<!--Sensitive Emails per sender-->
					<div class="bs-col-6 bs-col-large-4 " style="height: clamp(350px,50vh,405px);" *ngIf="userInfo.type !== dic.CONSTANTS.userTypes.dlp"
					     [appTrendsComparisonCard]="{key: 'classificationSensitiveSenderChartOptions', chartRefKey: 'classificationSensitiveSenderChart'}">
						<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Top Senders of Sensitive Emails</h6>
								</div>
								<span class="opacity-75 fw-500 text-start" style="height: 16px;">
									Senders who most frequently send sensitive emails
								</span>
							</div>
							<div class="flex-column f-1-0 centralize animated fadeIn">
								<apx-chart style="width: 100%; flex: 1 0;"
										   *ngIf="classificationSensitiveSenderChartOptions?.xaxis?.categories?.length && !getTrendsDataInProcess"
										   #classificationSensitiveSenderChart
										   [series]="classificationSensitiveSenderChartOptions.series"
										   [chart]="classificationSensitiveSenderChartOptions.chart"
										   [plotOptions]="classificationSensitiveSenderChartOptions.plotOptions"
										   [colors]="classificationSensitiveSenderChartOptions.colors"
										   [xaxis]="classificationSensitiveSenderChartOptions.xaxis"
										   [dataLabels]="classificationSensitiveSenderChartOptions.dataLabels"></apx-chart>
							</div>
							<trends-comparison-chart></trends-comparison-chart>

							<!--tips modal-->
							<div class="trends-card-actions-menu tips" style="right: 20px !important;"
								 *ngIf="classificationSensitiveSenderChartOptions && userInfo.type !== dic.CONSTANTS.userTypes.dlp"
								 [ngClass]="{'active' : showSensitiveSenderTips}">
								<i class="far fa-lightbulb" id="showSensitiveSenderTips" tooltip="Tips"
								   (click)="showSensitiveSenderTips = !showSensitiveSenderTips"></i>
								<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
									 [ngClass]="{'active' : showSensitiveSenderTips}">
									<ul style="cursor: default;" (clickOutside)="showSensitiveSenderTips = false;"
										[exclude]="'#showSensitiveSenderTips'" >
										<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
											<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
											<span class="fw-500">Click on any bar to view the emails with this type.</span>
										</div>
									</ul>
								</div>
							</div>

							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!classificationSensitiveSenderChartOptions?.xaxis?.categories?.length || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

					<!--Compliance types-->
					<div class="bs-col-6 bs-col-large-4 " style="height: clamp(350px,50vh,405px);"
					     [appTrendsComparisonCard]="{key: 'classificationComplianceTypesChartOptions', chartRefKey: 'complianceTypesChart'}">
						<div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
							<div class="flex-column align-items-start gap-1">
								<div class="flex-row align-items-center gap-1">
									<h6 class="m-0 fw-bold text-nowrap">Compliance Violation Breakdown</h6>
								</div>
								<span class="opacity-75 fw-500 text-start" style="height: 16px;">
									Breakdown of each violated compliance type
								</span>
							</div>
							<div class="flex-column f-1-0 centralize animated fadeIn">
								<apx-chart class="pie-chart pie-chart-left" style="width: 100%; height: 100%;"
										   *ngIf="classificationComplianceTypesChartOptions?.series?.length && !getTrendsDataInProcess"
										   #complianceTypesChart
										   [series]="classificationComplianceTypesChartOptions.series"
										   [chart]="classificationComplianceTypesChartOptions.chart"
										   [plotOptions]="classificationComplianceTypesChartOptions.plotOptions"
										   [dataLabels]="classificationComplianceTypesChartOptions.dataLabels"
										   [colors]="classificationComplianceTypesChartOptions.colors"
										   [labels]="classificationComplianceTypesChartOptions.labels"></apx-chart>
							</div>
							<trends-comparison-chart></trends-comparison-chart>

							<!--tips modal-->
							<div class="trends-card-actions-menu tips" style="right: 20px !important;"
								 *ngIf="classificationComplianceTypesChartOptions && userInfo.type !== dic.CONSTANTS.userTypes.dlp"
								 [ngClass]="{'active' : showComplianceTypesTips}">
								<i class="far fa-lightbulb" id="showComplianceTypesTips" tooltip="Tips"
								   (click)="showComplianceTypesTips = !showComplianceTypesTips"></i>
								<div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
									 [ngClass]="{'active' : showComplianceTypesTips}">
									<ul style="cursor: default;" (clickOutside)="showComplianceTypesTips = false;"
										[exclude]="'#showComplianceTypesTips'" >
										<div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
											<i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
											<span class="fw-500">Click on any pie slice to view the emails with this type.</span>
										</div>
									</ul>
								</div>
							</div>

							<!--loader / placeholder-->
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!classificationComplianceTypesChartOptions?.series?.length || getTrendsDataInProcess">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

	</div>
</div>


<popup-c *ngIf="emailsPopup?.show"
		 head="Emails" size="large"
		 (closeCb)="emailsPopup = null;">
	<div class="flxClmn f-1-0" style="overflow: auto;">
		<trustifi-table-c
			class="trustifi-table short-action-column" style="flex: 1 0; z-index: 5;"
			[list]="emailsPopup.emails"
			[headers]="[
				{text: 'Created', sortKey: 'created', width: '16%'},
				{text: 'Subject', sortKey: 'sent.title'},
				{text: 'From', sortKey: 'from.email'},
				{text: 'Recipients'},
				{text: 'Sensitivity', sortKey: 'sensitivity.score', width: '10%'},
			]"
			[cellsPrototype]="[
				{textKey: 'created', textType: 'dateAndTime'},
				{textKey: 'sent.title'},
				{html: 'fromCell'},
				{html: 'recipientsCell'},
				{html: 'sensitivityCell'},
			]"
			[cellActions]="{
				enable: true,
				selectItemActionCb:	selectEmailAction,
				initActionsFunction: showEmailActions
			}"
			(searchFunction)="searchEmails($event)"
			[options]="{
				isEllipsis: false,
				itemsNameSingular: 'email',
				defaultSortKey: '-created'
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<div class="ellipsis" *ngIf="cellId === 'recipientsCell'">
					<span *ngFor="let rcpt of item.recipients_display_only.to" tooltip="{{rcpt.address}}">
						{{rcpt.address}}<br/>
					</span>
					<span *ngFor="let rcpt of item.recipients_display_only.cc" tooltip="{{rcpt.address}}">
						{{rcpt.address}}<br/>
					</span>
				</div>

				<div class="ellipsis" *ngIf="cellId === 'fromCell'">
					<span tooltip="{{item.from.email}}">{{item.from.email}}</span>
				</div>

				<div *ngIf="cellId === 'sensitivityCell'">
					<input type="button" value="{{item.sensitivity.score}}"
						   [ngStyle]="item.sensitivity.score === 0 && {'background':'limegreen'} || item.sensitivity.score < 4 && {'background':'darkorange'} || item.sensitivity.score < 5 && {'background':'#FF851B'} || item.sensitivity.score === 5 && {'background':'#FF4136'}"
						   (click)="openSensitiveInfoPopup(item)"
						   class="redborder" style="background: orange; width: 25px; height: 25px; color: white !important; border: 0; margin-left: 3px; margin-top: -4px;"
						   placement="right"
						   tooltip="Sensitivity score is {{item.sensitivity.score}}. Click to review sensitivity details">
				</div>

			</ng-template>
		</trustifi-table-c>
	</div>
</popup-c>

<popup-c *ngIf="previewEmailContentPopup?.show"
		 head="{{previewEmailContentPopup.emailObj?.sent?.title || ''}}" size="large"
		 (closeCb)="previewEmailContentPopup = null">
	<div class="flxClmn f-1-0 vSpace1" style="overflow: auto;">
		<div class="flxRow hSpace05">
			<span style="flex-basis: 72px; flex-shrink: 0;">From: </span>
			<div *ngIf="previewEmailContentPopup.emailObj?.from">
				<span *ngIf="previewEmailContentPopup.emailObj?.from.name && previewEmailContentPopup.emailObj?.from.email && previewEmailContentPopup.emailObj?.from.name !== previewEmailContentPopup.emailObj?.from.email">{{previewEmailContentPopup.emailObj?.from.name}} <{{previewEmailContentPopup.emailObj?.from.email}}></span>
				<span *ngIf="!previewEmailContentPopup.emailObj?.from.name || !previewEmailContentPopup.emailObj?.from.email || previewEmailContentPopup.emailObj?.from.name === previewEmailContentPopup.emailObj?.from.email">{{previewEmailContentPopup.emailObj?.from.name || previewEmailContentPopup.emailObj?.from.email}}</span>
			</div>
		</div>

		<!--To-->
		<div class="flxRow hSpace05">
			<span style="flex-basis: 72px; flex-shrink: 0;">To: </span>
			<span>
				{{showFullToStr ? previewEmailContentPopup.emailObj?.recipientsToStrFull : previewEmailContentPopup.emailObj?.recipientsToStr}}&nbsp;
				<a class="blue-link" style="text-decoration: underline;"
				   *ngIf="previewEmailContentPopup.emailObj?.recipientsToStr && previewEmailContentPopup.emailObj?.recipientsToStrFull !== previewEmailContentPopup.emailObj?.recipientsToStr"
				   (click)="showFullToStr = !showFullToStr">
					{{showFullToStr ? 'Close' : 'Show all (' + previewEmailContentPopup.emailObj?.recipients_display_only.to.length + ')'}}
				</a>
			</span>
		</div>

		<!--Cc-->
		<div class="flxRow hSpace05" *ngIf="previewEmailContentPopup.emailObj?.recipients_display_only.cc?.length">
			<span style="flex-basis: 72px; flex-shrink: 0;">Cc: </span>
			<span>
				{{showFullCcStr ? previewEmailContentPopup.emailObj?.recipientsCcStrFull : previewEmailContentPopup.emailObj?.recipientsCcStr}}&nbsp;
				<a class="blue-link" style="text-decoration: underline;"
				   *ngIf="previewEmailContentPopup.emailObj?.recipientsCcStr && previewEmailContentPopup.emailObj?.recipientsCcStrFull !== previewEmailContentPopup.emailObj?.recipientsCcStr"
				   (click)="showFullCcStr = !showFullCcStr">
					{{showFullToStr ? 'Close' : 'Show all (' + previewEmailContentPopup.emailObj?.recipients_display_only.cc.length + ')'}}
				</a>
			</span>
		</div>

		<!--Date-->
		<div class="flxRow hSpace05">
			<span style="flex-basis: 72px; flex-shrink: 0;">Sent at: </span>
			<span>{{(previewEmailContentPopup.emailObj?.created | date:'MM/dd/yyyy HH:mm') || 'Not sent yet'}}</span>
		</div>

		<div class="flex-row centralize f-1-0 hide-when-empty-force">
			<loader class="opacity-75" *ngIf="previewEmailContentPopup.getEmailContentInProcess"></loader>
			<span class="text-danger" *ngIf="previewEmailContentPopup.error">Error: {{previewEmailContentPopup.error}}</span>
		</div>

		<email-viewer class="animated fadeIn" style="overflow: auto; flex: 1 0; width: 100%; min-width: 220px; border: 1px solid #ccc;"
					  [content]="previewEmailContentPopup.emailObjContent.sent.html"
					  *ngIf="previewEmailContentPopup.emailObjContent?.sent?.html"></email-viewer>

		<div class="flex-row gap-1" style="flex:1 0; margin-top: 7px; align-items: flex-start; flex-wrap: wrap;" *ngIf="previewEmailContentPopup.emailObjContent?.sent?.attachments?.length">
			<attachment-c *ngFor="let file of previewEmailContentPopup.emailObjContent.sent.attachments"
						  [attName]="file.name"
						  [attSize]="file.size"
						  [downloadProgress]="file.downloadProgressPrecentage"
						  (preview)="setPreviewAttachment(previewEmailContentPopup.emailObjContent, file);">
			</attachment-c>
		</div>

	</div>
</popup-c>

<attachment-preview
	*ngIf="previewAttachment"
	[attachment]="previewAttachment"
	(onClose)="previewAttachment = null;"
	[url]="previewAttachment.url">
</attachment-preview>


<sensitivity-details
	*ngIf="showSensitiveInfoPopup?.show"
	type="email"
	[origin]="'rules'"
	[scanItemObj]="showSensitiveInfoPopup.email"
	(cancelCb)="showSensitiveInfoPopup = null;"
	[scanTitle]="showSensitiveInfoPopup.emailTitle"
	[sensitivity]="showSensitiveInfoPopup.sensitivity">
</sensitivity-details>

